// extracted by mini-css-extract-plugin
export default {"boxContainer":"description_boxContainer__Zj67g","container":"description_container__1hjF+","text":"description_text__vpJNt","image":"description_image__na23s"};